import _ from 'lodash';
import LocalStoreService from './api/store';
import FetchService from './api/base.fetch';
import Api from './api/index';
import Emitter from './emitter';
import CONSTANT from '../constant';
import Connect from './connect';
import {
    requestExt,
    translateRequestUrlForEU,
    getExtResPath
} from '../util/index';
import {
    isWeb
} from '../util/env';
import {
    message
} from 'antd';
import driverManger from './driverManger';
import dialog from '../components/configui/dialog';

export default function (store) {

    // setMessages(store.getState().intlr.messages);

    if (!window.MbApi) {
        window.MbApi = {};
    }
    // antd 组件
    // window.MbApi.antd = {
    //     Switch
    // };
    // Iot 服务
    window.MbApi.IotService = Api.IotService;
    // 本地存储服务
    window.MbApi.LocalStoreService = LocalStoreService;
    // 获取 Token
    window.MbApi.getToken = () => {
        return LocalStoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY);
    };
    // 获取通用的 header 配置
    window.MbApi.getCommonHeader = () => {
        return {
            'accesstoken': LocalStoreService.get(CONSTANT.USER_ACCESS_ACCESSTOKEN_KEY),
            'token': LocalStoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY),
        };
    };
    // 获取用户信息
    window.MbApi.getUserInfo = () => {
        return LocalStoreService.get(CONSTANT.USER_INFO_KEY);
    };
    // 获取连接的设备类型
    window.MbApi.getDeviceType = () => {
        return '1'; // LocalStoreService.get(CONSTANT.CONNECT_DEVICE_KEY);
    };
    // 获取设备 MAC 地址
    window.MbApi.getDeviceId = () => {
        return LocalStoreService.get(CONSTANT.CONNECT_DEVICE_ID_KEY);
    };
    // 获取 IOT 云列表请求域名
    window.MbApi.cloudListDomain = () => {
        return translateRequestUrlForEU(FetchService.domainconfig.iot);
    };
    // 获取 IOT 天气请求域名
    window.MbApi.weatherDomain = () => {
        return translateRequestUrlForEU(FetchService.domainconfig.weather);
    };
    // 获取 IOT 空气质量请求域名 & 获取 AI 接口请求域名
    window.MbApi.airDomain = () => {
        return translateRequestUrlForEU(FetchService.domainconfig.air);
    };

    //通用服务通信通道
    window.MbApi.getServiceChannel = () => {
        return Connect.serviceChannel;
    };

    // 中间件
    window.MbApi.middlewares = {
        /**
         *  编译
         *
         * @param {string} context arduino 内容
         * @param {({ log: '编译日志', code: '编译后的代码', err: '编译失败' }) => void`} 回调函数
         * @param {string} type
         */
        compiler: (context, callback, type = 'arduino') => {
            Connect.compiler({
                type,
                context
            }, callback);
        },
        /**
         * 上传到 Flash
         *
         * @param {string} [param={ hex: string, lib: string }]
         * @param {({ percent?: number, success?: boolean, err?: object }) => void`} 回调函数
         * @param {string} type 上传的类型
         */
        uploadFlash: (param = {
            hex: '',
            lib: '',
            board: ''
        }, callback, type = 'arduino') => {
            try {
                const {
                    connect
                } = store.getState();
                let device = _.filter(connect.devices, {
                    deviceId: param.board
                });
                if (!_.isEmpty(device) && _.isArray(device)) {
                    let path = device[0].address;
                    delete param['board'];
                    Connect.flash({
                        type,
                        context: {
                            path,
                            ...param
                        }
                    }, callback);
                }
            } catch (error) {
                console.warn(error);
            }
        },
        /**
         * 烧录到microbit
         */
        uploadMicrobit: (context, callback, type = 'upload') => {
            Connect.microbit(type, context, callback);
        },
    };

    // 触发项目改变状态
    window.MbApi.projectChange = () => {
        Emitter.emit('ProjectChange');
    };

    // 获取扩展资源路径
    window.MbApi.getExtResPath = getExtResPath;
    // require
    window.MbApi.require = requestExt;
    // Event
    window.MbApi.Emitter = Emitter;

    window.MbApi.isWeb = isWeb;
    window.MbApi.dialog = (id, config) => {
        return dialog(id, config);
    };
    window.MbApi.message = (msg = '', type = 'info', duration = 2, onClose) => {
        const messages = store.getState().intlr.messages;
        if (_.has(messages, msg)) {
            msg = messages[msg];
        }
        if (msg) {
            message[type](msg, duration, onClose);
        }
    };
    window.MbApi.getServiceKey = (type = '', option = {}) => {
        return Api.UserService.accesstoken();
        // getServiceKey({
        //     'type': 'tts',
        //     'option':{
        //       expire:30，
        //     }
        //   })
    };

    window.MbApi.registerFirmwareDriver = driverManger.addFirmwareDriver.bind(driverManger);
    window.MbApi.registerUploadDriver = driverManger.addUploadDriver.bind(driverManger);
    window.MbApi.registerUploadMiddleware = driverManger.addMiddleware.bind(driverManger);

}

/**
 * 提示
 *
 * @param {string} [msg=''] 提示内容
 * @param {string} [type='info'] 提示类型 <'success' | 'error' | 'info' | 'warning' | 'warn' | 'loading'>
 * @param {number} [duration=1.5] 自动关闭的延时，单位秒
 * @param {any} onClose 关闭时触发的回调函数
 */
const alert = function (msg = '', type = 'info', duration = 2, onClose) {
    if (msg) {
        message[type](msg, duration, onClose);
    }
};

window.alert = alert;